/** @jsx jsx */

import { Spacing } from '@zapier/theme';
import { css, jsx } from '@emotion/core';

import BundleConsoleHttpBase from '../BundleConsoleHttpBase';
import HttpLog from '../Logs/HttpLog';

import { RequestMethodTypes } from 'app/developer-v3/types/request';

const Styles = {
  logItem: css`
    &:not(:first-child) {
      margin-top: ${Spacing.small}px;
    }
  `,
};

type Log = {
  id: string;
  category: '2xx' | '3xx' | '4xx' | '5xx';
  date: string;
  request_data: string;
  request_duration_ms: number;
  request_headers: string;
  request_method: RequestMethodTypes;
  request_url: string;
  request_params?: string;
  response: string;
  response_content: string;
  response_headers: string;
  response_status_code: number;
};

type Props = {
  isLoading: boolean;
  logs: Array<Log>;
  onClickTestAgain: () => void;
};

function Http({ isLoading, logs, onClickTestAgain }: Props) {
  return (
    <BundleConsoleHttpBase
      isLoading={isLoading}
      onClickTestAgain={onClickTestAgain}
    >
      {logs.length > 0 ? (
        <ul>
          {logs.map((log, index) => (
            <li css={Styles.logItem}>
              <HttpLog
                date={log.date}
                isInitiallyExpanded={index === 0}
                key={log.id}
                requestData={log.request_data}
                requestHeaders={log.request_headers}
                requestMethod={log.request_method}
                requestParams={log.request_params}
                requestUrl={log.request_url}
                responseContent={log.response_content}
                responseHeaders={log.response_headers}
                responseStatusCode={log.response_status_code}
              />
            </li>
          ))}
        </ul>
      ) : null}
    </BundleConsoleHttpBase>
  );
}

Http.defaultProps = {
  isLoading: false,
  logs: [],
};

export default Http;
